/**
 * Component Entry
 *
 */

import Badge from './Badge'
export default Badge
export * from './Badge'
